import React from 'react'
import Profpic from '../Components/profilesection/Profpic'


function Profile() {
  return (
    <>
      < Profpic />
    </>
  )
}

export default Profile